import FallBackAssets from './FallBackAssets';

export default FallBackAssets;
